import { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import Modal from "react-modal";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";

const FarmerCropCutList = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getFarmerTemplate } = useHttp();

  const getData = () => {
    getFarmerTemplate(
      {
        url: `/api/FarmerCropCutDetailList/?orgId=${localStorage.getItem("orgId")}&&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          console.log(res);
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const { sendRequest: entryDelete } = useHttp();

  const handleDelete = (e, cropCutId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content:
        "Are you sure you want to delete this farmer crop cut detail?",
      onOk() {
        const data = {
          cropCutId: cropCutId,
          serviceId: sId,
          createdBy:localStorage.getItem("empId")
        };
        //console.log(data);

        entryDelete(
          {
            url: "/api/cropCutDetail/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success("Data deleted successfully");
            getDetailView();
          }
        );
      },
      onCancel() {},
    });
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.stockDailyClosingDate?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.warehouseName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    console.log(data);

    const cropCutId = data && data.cropCutId;
     
     
        setSelectedData(data);
      
    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    // console.log(approvalStatus);
    let data = "";
    if (approvalStatus === "approve") {
      data = {
        itemId:
          selectedApprovalData && selectedApprovalData.cropCutId,
        approved: 1,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "disapprove") {
      data = {
        itemId:
          selectedApprovalData && selectedApprovalData.cropCutId,
        approved: 2,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "sendNextApprove") {
      data = {
        itemId:
          selectedApprovalData && selectedApprovalData.cropCutId,
        approved: 0,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 1,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    }

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/farmerCropCutApproval/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        getData();
      }
    );
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">Farmer Crop Cut Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>

        {selectedData && (
          <div className="mx-3">
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
              <b> Doc No:</b> {selectedData.docNo}
              </p>
              <p className="col-md-6">
              <b> Crop Cut Date :</b> {selectedData.cropCutDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
              <b>Farmer Name:</b> {selectedData.farmerName}
              </p>
              <p className="col-md-6">
              <b>  Field Executive Name :</b> {selectedData.employeeName}
              </p>
            </div>

            <div className="row">
            <p className="col-md-6" style={{ textAlign: "left" }}>
                <b>Plot Name/Id:</b> {selectedData.plotName}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
              <b>Crop Name:</b> {selectedData.cropName+'('+selectedData.varietyName+')'}
              </p>
            </div>

            <h5 className="card-title"> <b>Product Details</b></h5>
            <table className="table table-bordered text-center">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Grade Name</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                       <tr >
                        <td>1</td>
                        <td>Crop Cut Weight A</td>
                        <td>{selectedData.cropCutWeightA}</td>
                        

                        <td>Kg</td>
                    
                      </tr>

                      <tr >
                        <td>2</td>
                        <td>Crop Cut Weight B</td>
                        <td>{selectedData.cropCutWeightB}</td>

                        <td>Kg</td>
                    
                      </tr>

                      <tr >
                        <td>3</td>
                        <td>Crop Cut Weight C</td>
                        <td>{selectedData.cropCutWeightC}</td>

                        <td>Kg</td>
                    
                      </tr>

                      <tr >
                        <td>4</td>
                        <td>Crop Cut Weight D</td>
                        <td>{selectedData.cropCutWeightD}</td>

                        <td>Kg</td>
                    
                      </tr>
                     
              </tbody>
            </table>
          </div>
        )}
      </Modal>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Farmer Crop Cut 
            </label>
          </div>

          {/* <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Farmer Input Template
              </button>
            )}
          </div> */}
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered table-responsive text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Doc No</th>
                          <th>Farmer Name</th>
                          <th>Farmer Code/Id </th>  
                          <th>Crop Name </th>
                          <th>Executive Name</th>
                          <th>Approve</th>
                          <th>Approved by</th>

                          {canView === "block" && <th>View</th>}
                          {canEdit === "block" && <th>Edit</th>}

                          <th>Delete</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.cropCutDate}</td>
                                <td>{itm.docNo}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.farmerNo}</td>

                                <td>{itm.cropName}</td>
                                <td>{itm.employeeName}</td>

                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    // disabled={
                                    //   itm.nextlevel == 1
                                    //     ? itm.allowApproveUserId == loginUserId
                                    //       ? false
                                    //       : true
                                    //     : itm.approved == 0 &&
                                    //       itm.reportingId == loginUserId
                                    //     ? false
                                    //     : true
                                    // }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                <td>{itm.approvedByName}</td>

                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                      
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}

                                {canEdit === "block" && (
                                  <td>
                                    <button
                                      onClick={() => {
                                        props.addForm(true);
                                        sId(serviceId);
                                        props.update(itm);
                                      }}

                                      disabled={
                                        itm.approved == 0 ? false
                                         : true
                                     }
                                      // disabled={
                                      //   itm.nextlevel == 1
                                      //     ? itm.allowApproveUserId == loginUserId
                                      //       ? false
                                      //       : true
                                      //     : itm.approved == 0 &&
                                      //       itm.reportingId == loginUserId
                                      //     ? false
                                      //     : true
                                      // }
                                      className="btn"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  </td>
                                )}
                                {canDelete === "block" && (
                                  <td>
                                    <button
                                      type="button"
                                      disabled={
                                         itm.approved == 0 ? false
                                          : true
                                      }
                                      onClick={(e) =>
                                        handleDelete(
                                          e,
                                          itm.cropCutId
                                        )
                                      }
                                      className="btn"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Farmer Crop Cut Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("approve");
            }}
          >
            Approve
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => {
              handleApprovalSubmit("disapprove");
            }}
            className="btn btn-sm btn-primary"
          >
            Disapprove
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("sendNextApprove");
            }}
          >
            Send Next Approve
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default FarmerCropCutList;
